import { IQService, auto, IHttpInterceptor } from 'angular';
import { I18n } from '../../i18n/mx-internationalization';
import { HttpResponse } from '../../Types/HttpResponse';
import type { ErrorPosterService } from '../../ErrorPage/error-poster.service';

http503Interceptor.$inject = ['$q', '$injector', 'mx.internationalization'];

export function http503Interceptor($q: IQService, $injector: auto.IInjectorService, i18n: I18n): IHttpInterceptor {
	return {
		responseError: function (response: HttpResponse<any>) {
			if (response.status === 503) {
				const noCertificate = response.data && response.data.error_code === 'NO_VALID_CERTIFICATE';

				// noinspection SpellCheckingInspection
				const title = noCertificate
					? i18n.get('shell.mx-shell-error-message.no_certificate_title') || 'No License / Keine Lizenz'
					: i18n.get('shell.mx-shell-error-message.maintenance_mode_title') || 'Maintenance mode / Wartungsmodus';

				// noinspection SpellCheckingInspection
				const content = noCertificate
					? i18n.get('shell.mx-shell-error-message.no_certificate_text') || 'No valid License found / Es gibt keine gültigen Lizenz'
					: i18n.get('shell.mx-shell-error-message.maintenance_mode_text') || 'Please try again later / Warten Sie bitte';

				const errorPosterService = $injector.get('mx.sb.ErrorPage.PosterService') as ErrorPosterService;

				errorPosterService.show(title, content);
				if (response) {
					response.skipNotification = true;
					response.message = content;
					response.title = title;
				}
			}
			return $q.reject(response);
		},

		response: function (response: HttpResponse<any>) {
			const errorPosterService = $injector.get('mx.sb.ErrorPage.PosterService') as ErrorPosterService;
			if (errorPosterService.isShown && response.config.url.includes('m42Services')) {
				errorPosterService.hide();
			}
			return response;
		},
	};
}
